import { useAuthStore } from '@/stores/authStore';
import { useSubscriptionStore } from '@/stores/subscriptionStore';

/**
 * El UNICO sitio del cliente que decide si una feature de plan esta bloqueada.
 *
 * Antes esta expresion vivia inline en Sidebar.tsx (L170-176) y era lo unico que
 * existia: no habia guarda de ruta ninguna. Si el menu lateral y la guarda
 * calculasen el bloqueo por separado, un dia uno ensenaria candado y el otro
 * dejaria entrar.
 *
 * Reglas, en este orden:
 *   - super admin  -> nunca bloqueado (es el operador de Pleko, da soporte).
 *   - trial        -> nunca bloqueado: `planConfig()` del servidor resuelve el
 *                     bloque SCALE para el trial, asi que el cliente debe
 *                     coincidir con el servidor o ensenaria un candado sobre
 *                     algo que la API deja pasar (D-05).
 *   - sin `status` cargado todavia -> NO bloqueado. Preferimos dejar entrar y
 *                     que la API conteste 402 (que la pantalla sabe pintar) a
 *                     ensenar un muro de pago por un store aun sin rellenar.
 *   - resto        -> lo que diga plan_config.features[feature].
 */
export function useIsFeatureLocked(feature: string): boolean {
  const isSuperAdmin = useAuthStore((s) => s.user?.is_admin === true);
  const status = useSubscriptionStore((s) => s.status);

  if (isSuperAdmin) return false;
  if (!status?.plan_config?.features) return false;
  if (status.active_plan === 'trial') return false;

  return !(status.plan_config.features as Record<string, boolean>)[feature];
}
